import type { ComponentEntry } from '../../core/common-types'

const entry: ComponentEntry = {
	componentType: 'PageMountUnmount',
	loadComponent: () => import('./PageMountUnmount.js' /* webpackChunkName: "PageMountUnmount" */),
}

export default entry
